import React from 'react';
import Button from 'atoms/Button/Button';
import Stack from 'atoms/Layout/Stack/Stack';
import Grid from 'atoms/Layout/Grid/Grid';
import HeadingAndSupportingText from 'molecules/HeadingAndSupportingText/HeadingAndSupportingText';
import HubspotFormWrapper from 'molecules/HubspotForm/HubspotFormWrapper';
import useBookACallFormHandler from 'src/hooks/useBookACallFormHandler';

const FORM_WRAPPER_ID = 'footer-sales-call-form';

const FooterSalesCallEmailBlock = (): JSX.Element => {
  const { isLoading, submitFormAndRedirect } = useBookACallFormHandler(FORM_WRAPPER_ID);

  return (
    <Grid
      totalColumns={1}
      background='bg-secondary'
      borderRadius='radius-2xl'
      padding='spacing-4xl'
      gap='spacing-4xl'
      dataColorMode='dark'
      maxWidth='width-xs'
      marginLeft='spacing-lg'
      marginLeftLg='spacing-none'
    >
      <HeadingAndSupportingText
        heading={{
          type: 'heading',
          size: 'sm',
          fontWeight: 'font-weight-semibold',
          text: 'Book a Sales Call',
          color: 'text-primary-on-brand',
        }}
        supportingText={{
          type: 'paragraph',
          color: 'brand-500',
          size: 'lg',
          fontWeight: 'font-weight-medium',
          text: 'Talk to our team to understand if branded apps and our services are right for you',
        }}
        gap='spacing-xs'
      />
      <Stack
        direction='column'
        gap='spacing-xl'
      >
        <Stack dataColorMode='light'>
          <HubspotFormWrapper
            id={FORM_WRAPPER_ID}
            hideInputLabels
            hideLegal
          />
        </Stack>
        <Button
          variant='primary'
          size='xl'
          onClick={submitFormAndRedirect}
          disabled={isLoading}
        >
          Book a Sales Call
        </Button>
      </Stack>
    </Grid>
  );
};

export default FooterSalesCallEmailBlock;
